import {
  TipTile,
} from '../types';


const transformTipTile = (rawTipTileData: any): (TipTile | void) => {
  // !FIXME: we are picking desktop instead of mobile for the aspect ratios
  // ? when PLP was changed from list to grid, the old aspect ratios of...
  // mobile no longer suit the grid...
  const {
    url_d: url,
    image_in_list: imageInList,
  } = rawTipTileData;

  if (url && imageInList?.desktop) {
    return {
      url,
      imageSrc: imageInList?.desktop,
    };
  }
};


export default transformTipTile;
